export const appApiRoutes = {
  employees: {
    get: 'employees/:id',
    me: 'employees/me',
    list: 'employees',
    create: 'employees',
    update: 'employees/:id',
    delete: 'employees/:id',
    rolesOptions: 'employees/role-options',
    typesOptions: 'employees/type-options',
    options: 'employees/options',
    bulkDelete: 'employees/bulk-delete',
  },
  travelers: {
    get: 'travelers/:id',
    list: 'travelers',
    create: 'travelers',
    update: 'travelers/:id',
    delete: 'travelers/:id',
    titleOptions: 'travelers/title-options',
    genderOptions: 'travelers/gender-options',
    typeOptions: 'travelers/type-options',
    wheelchairOptions: 'travelers/wheelchair-options',
    companyTravelersOptions: 'travelers/options/:companyId',
    companyTravelersManagersOptions: 'travelers/company-options/:companyId',
    options: 'travelers/options',
  },
  travelerInfo: {
    sourceOptions: 'traveler-info/source-options',
  },
  travelerManagers: {
    get: 'traveler-managers/:id',
    list: 'traveler-managers',
    create: 'traveler-managers',
    update: 'traveler-managers/:id',
    delete: 'traveler-managers/:id',
    options: 'traveler-managers/options/:companyId',
  },
  orders: {
    get: 'orders/:id',
    list: 'orders',
    getKanban: 'orders/kanban',
    listQuotes: 'orders/quotes',
    listBookings: 'orders/bookings',
    listTravelerQuotes: 'orders/quotes/traveler',
    listTravelerBookings: 'orders/bookings/traveler',
    create: 'orders',
    moveToQuote: 'orders/:id/move-to-quote',
    createWithQuote: 'orders/create-with-quote',
    update: 'orders/:id',
    updateAssignee: 'orders/:id/assignee',
    delete: 'orders/:id',
    archive: 'orders/:id/archive',
    taskOptions: 'orders/options/task-options',
  },
  itineraries: {
    get: 'itineraries/:id',
    list: 'itineraries',
    create: 'itineraries',
    update: 'itineraries/:id',
    updatePrices: 'itineraries/:id/prices',
    updatePriceDisplayed: 'itineraries/:id/price-displayed',
    updatePosition: 'itineraries/position',
    duplicate: 'itineraries/:id/duplicate',
    moveToBooking: 'itineraries/:id/booking',
    delete: 'itineraries/:id',
  },
  itineraryItems: {
    get: 'itinerary-items/:id',
    list: 'itinerary-items',
    create: 'itinerary-items',
    update: 'itinerary-items/:id',
    updatePosition: 'itinerary-items/position',
    delete: 'itinerary-items/:id',
  },
  itineraryFlights: {
    updateFlightClass: 'itinerary-flights/:id/flight-class',
  },
  airports: {
    get: 'airports/:id',
    list: 'airports',
    delete: 'airports/:id',
    bulkDelete: 'airports/bulk-delete',
    options: 'airports/options',
    update: 'airports/:id',
  },
  airlines: {
    get: 'airlines/:id',
    list: 'airlines',
    create: 'airlines',
    update: 'airlines/:id',
    delete: 'airlines/:id',
    bulkDelete: 'airlines/bulk-delete',
    options: 'airlines/options',
  },
  suppliers: {
    get: 'suppliers/:id',
    list: 'suppliers',
    create: 'suppliers',
    update: 'suppliers/:id',
    delete: 'suppliers/:id',
    bulkDelete: 'suppliers/bulk-delete',
  },
  orderQuotes: {
    get: 'order-quotes/:id',
    generatePdfs: 'order-quotes/generate-pdfs',
    sendPdfs: 'order-quotes/send-pdfs',
    sendQuote: 'order-quotes/send-quote',
    createOrderQuoteTraveler: 'order-quotes/traveler',
    update: 'order-quotes/:id',
    duplicate: 'order-quotes/:id/duplicate',
    archive: 'order-quotes/:id/archive',
    updateMainTraveler: 'order-quotes/:id/main-traveler',
    updateOrderQuoteTraveler: 'order-quotes/:id/update-traveler',
    deleteOrderQuoteTraveler: 'order-quotes/:id/delete-traveler/:traveler',
    delete: 'order-quotes/:id',
  },
  accommodations: {
    get: 'accommodations/:id',
    list: 'accommodations',
    create: 'accommodations',
    update: 'accommodations/:id',
    delete: 'accommodations/:id',
    bulkDelete: 'accommodations/bulk-delete',
    options: 'accommodations/options',
  },
  orderQuotePdfs: {
    list: 'order-quote-pdfs',
    delete: 'order-quote-pdfs/:id',
    pdfPreview: 'order-quote-pdfs/:id/preview',
  },
  orderQuotePdfSend: {
    list: 'order-quote-pdf-send',
    get: 'order-quote-pdf-send/:id',
  },
  orderBookings: {
    get: 'order-bookings/:id',
    duplicate: 'order-bookings/:id/duplicate',
    duplicateQuote: 'order-bookings/:id/duplicate-quote',
  },
  orderQuoteNotes: {
    list: 'order-quote-notes',
    create: 'order-quote-notes',
  },
  destinations: {
    options: 'destinations/options',
  },
  travelerAllergies: {
    list: 'traveler-allergies',
  },
  travelerFrequentFlights: {
    list: 'traveler-frequent-flights',
  },
  travelerHotelLoyalties: {
    list: 'traveler-hotel-loyalties',
  },
  travelerPassports: {
    list: 'traveler-passports',
  },
  travelerRequirements: {
    list: 'traveler-requirements',
  },
  travelerVisas: {
    list: 'traveler-visas',
  },
  carHireSuppliers: {
    get: 'car-hire-suppliers/:id',
    list: 'car-hire-suppliers',
    create: 'car-hire-suppliers',
    update: 'car-hire-suppliers/:id',
    delete: 'car-hire-suppliers/:id',
    bulkDelete: 'car-hire-suppliers/bulk-delete',
    options: 'car-hire-suppliers/options',
  },
  transferVendors: {
    get: 'transfer-vendors/:id',
    list: 'transfer-vendors',
    create: 'transfer-vendors',
    update: 'transfer-vendors/:id',
    delete: 'transfer-vendors/:id',
    bulkDelete: 'transfer-vendors/bulk-delete',
    options: 'transfer-vendors/options',
  },
  railSuppliers: {
    get: 'rail-suppliers/:id',
    list: 'rail-suppliers',
    create: 'rail-suppliers',
    update: 'rail-suppliers/:id',
    delete: 'rail-suppliers/:id',
    bulkDelete: 'rail-suppliers/bulk-delete',
    options: 'rail-suppliers/options',
  },
  cruiseLines: {
    get: 'cruise-lines/:id',
    list: 'cruise-lines',
    create: 'cruise-lines',
    update: 'cruise-lines/:id',
    delete: 'cruise-lines/:id',
    bulkDelete: 'cruise-lines/bulk-delete',
    options: 'cruise-lines/options',
  },
  carTypes: {
    get: 'car-types/:id',
    list: 'car-types',
    create: 'car-types',
    update: 'car-types/:id',
    delete: 'car-types/:id',
    bulkDelete: 'car-types/bulk-delete',
    options: 'car-types/options',
  },
  tasks: {
    get: 'tasks/:id',
    list: 'tasks',
    create: 'tasks',
    update: 'tasks/:id',
    complete: 'tasks/:id/complete',
    delete: 'tasks/:id',
    schedule: 'tasks/schedule',
    getStatusOptions: 'tasks/options/status',
    updateStatus: 'tasks/:id/update-status',
    updateEmployee: 'tasks/:id/employee',
    updateDeadline: 'tasks/:id/deadline',
    updateDescription: 'tasks/:id/description',
    updateOrder: 'tasks/:id/order',
  },
  settings: {
    get: 'settings',
    getSchedule: 'settings/schedule',
    getDayWorkTime: 'settings/work-time/:date/day',
    getWeekWorkTime: 'settings/work-time/:date/week',
    getMonthWorkTime: 'settings/work-time/:date/month',
    update: 'settings',
    updateSchedule: 'settings/schedule',
  },
  companiesV2: {
    get: 'companies-v2/:id',
    list: 'companies-v2',
    options: 'companies-v2/options',
    create: 'companies-v2',
    update: 'companies-v2/:id',
    delete: 'companies-v2/:id',
  },
};
